import axios, { AxiosInstance } from "axios";
import * as React from "react";
import { Consumer } from "./axios-context";

export interface IAxiosProps {
  axios: AxiosInstance;
}

const cancelSourceSymbol = Symbol("withAxiosCancel");

export default function withAxios<P>(
  Component: React.ComponentType<IAxiosProps & P>
) {
  return class WithAxios extends React.Component<P> {
    private readonly [cancelSourceSymbol] = axios.CancelToken.source();

    public componentWillUnmount() {
      this[cancelSourceSymbol].cancel();
    }

    public render() {
      return (
        <Consumer>
          {(axiosInfo) => {
            const configWithCancel = {
              ...axiosInfo.config,
              cancelToken: this[cancelSourceSymbol].token,
            };
            const axiosInstance = axios.create(configWithCancel);
            for (const requestInterceptor of axiosInfo.requestInterceptors) {
              // TODO: Fix TypeScript flagged issue
              // @ts-ignore
              axios.interceptors.request.use(
                // TODO: Fix TypeScript flagged issue
                // @ts-ignore
                requestInterceptor.onFulfilled,
                requestInterceptor.onRejected
              );
            }
            for (const responseInterceptor of axiosInfo.responseInterceptors) {
              axios.interceptors.response.use(
                responseInterceptor.onFulfilled,
                responseInterceptor.onRejected
              );
            }
            return <Component {...this.props} axios={axiosInstance} />;
          }}
        </Consumer>
      );
    }
  };
}

export function isCancel(ex: any) {
  return axios.isCancel(ex);
}



// WEBPACK FOOTER //
// ./src/shared/components/withAxios.tsx